module.exports = __webpack_public_path__ + "static/img/4.149ce0b.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/11/sp/4.png
// module id = Rk/s
// module chunks = 0